<div class="flex flex-col gap-2">
  <div class="flex flex-row flex-wrap items-baseline gap-x-2">
    <strong class="title" data-test-id="expert-availability-best-matches-title">
      Best matches {{ period() }}
    </strong>
    <span class="description">
      Times you're both available, preferred first, clear of scheduled calls
    </span>
  </div>
  <div class="flex flex-row flex-wrap gap-3">
    @for (tile of tiles(); track tile.slot.range.start) {
      <button
        type="button"
        class="tile flex flex-col items-start gap-1"
        data-test-id="expert-availability-best-match"
        [attr.aria-disabled]="disabled() || null"
        [attr.aria-label]="`Select ${tile.date} ${tile.time}`"
        (click)="select(tile.slot)"
      >
        <span class="date" data-test-id="expert-availability-best-match-date">
          {{ tile.date }}
        </span>
        <span class="time" data-test-id="expert-availability-best-match-time">
          {{ tile.time }}
        </span>
        <span class="flex flex-row flex-wrap gap-1.5">
          <span
            class="tag expert flex flex-row items-center gap-1"
            data-test-id="expert-availability-best-match-expert"
          >
            <mat-icon>{{ tile.expert.icon }}</mat-icon>
            {{ tile.expert.label }}
          </span>
          <span
            class="tag client flex flex-row items-center gap-1"
            data-test-id="expert-availability-best-match-client"
          >
            <mat-icon>{{ tile.client.icon }}</mat-icon>
            {{ tile.client.label }}
          </span>
        </span>
      </button>
    } @empty {
      <span class="empty" data-test-id="expert-availability-best-matches-empty">
        {{ emptyText() }}
      </span>
    }
  </div>
</div>
